import CityPageTemplate from './CityPageTemplate';

export default function WinterParkPage() {
  return (
    <CityPageTemplate
      city="Winter Park"
      county="Orange"
      slug="winter-park"
      zipCodes={['32789', '32792']}
      neighborhoods={['Park Avenue', 'Rollins College Area', 'Winter Park Village', 'Maitland Border', 'Baldwin Park']}
      localContext="Serving Winter Park's prestigious Park Avenue corridor and the neighborhoods surrounding Rollins College, where homeowners expect perfection."
      metaDescription="Professional residential and commercial cleaning services in Winter Park, FL. Serving ZIP codes 32789 & 32792. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
